// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2dkEX","loaderOuter":"PageOverlayLoader_loaderOuter__1mXw_"};